import Make from './make'

const make = Make('explain/')

export const getAllGaDimensions = async (): Promise<any | null> => {
  const req = await make.get({
    endpoint: 'get-ga-custom-dimensions',
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

export const getAllGaMetrics = async (): Promise<GaMetric[] | null> => {
  const req = await make.get<{ metrics: GaMetric[] }>({
    endpoint: 'get-all-ga-metrics',
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data?.metrics || null
}

export const getCurrentKeyMetrics = async (): Promise<any> => {
  const req = await make.get<{
    metrics: KeyMetrics[]
  }>({
    endpoint: 'get-current-key-metrics',
  })
  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

export const getAnomalyDateDescription = async ({
  metric,
  date,
}: {
  metric: string
  date: string
}): Promise<any> => {
  const req = await make.get({
    endpoint: `get-anomaly-date-description/${metric}/${date}`,
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

export const getExplainSetup = async (): Promise<any> => {
  const req = await make.get<{
    pageLayout: ExplainLayout[]
    settings: ExplainSetup
  }>({
    endpoint: 'get-explain-page-layout',
  })
  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

interface AnomalyDescription {
  anomalyDateID: string
  anomalyNotInteresting?: boolean
  likedCauses?: any[]
  selectedRelevantDimensions?: any[]
  userSuppliedAction?: string
  userSuppliedCause?: string
}

export const updateAnomalyDescription = async (
  data: AnomalyDescription,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'update-anomaly-date-description',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface SaveExplainSetup {
  pageLayout: ExplainLayout[]
  settings: ExplainSetup
}

export const saveExplainSetup = async (
  data: SaveExplainSetup,
): Promise<boolean> => {
  const req = await make.put({
    endpoint: 'update-explain-page-layout',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}
interface UpdateMetric {
  detectionMethod?: 'SD' | 'AE' | 'MANUAL'
  displayName?: string
  increaseSentimentPositive?: boolean
  metricID: string
  nPeriods?: number
  nStandardDeviations?: number
  tPercentile?: number
  sendAlert?: boolean
}

export const updateMetric = async (data: UpdateMetric): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'update-key-metric',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface AddMetric {
  newMetric: string
  apiName: string
  detectionMethod: 'SD' | 'AE' | 'MANUAL'
  increaseSentimentPositive: boolean
  sendAlert: boolean
  dataSource: 'GA_VIEW' | 'AA_REPORT' | 'SALESFORCE'
}

export const addMetric = async (data: AddMetric): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'add-key-metric',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface AddCauseAction {
  increase: boolean
  internal: boolean
  metricDimGrp: string
  newAction: string
  newCause: string
  title: string
  actual: number
  difference: number
  expected: number
  metric: string
}

export const addCauseAction = async (
  data: AddCauseAction,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'add-cause-action',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface RemoveMetric {
  removeMetric: string
}

export const removeMetric = async (data: RemoveMetric): Promise<boolean> => {
  const req = await make.delete({
    endpoint: 'remove-key-metric',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}
